/*global google:false */
/*global PhotoSwipe:false */
/*global PhotoSwipeUI_Default:false */

window.bpLarge = 1280;
window.bpIPadMax = 1024;
window.bpMedium = 960;
window.bpIPadMin = 768;
window.bpSmall = 640;

/**
 * breakpoints
 */
window.width = $(window).width();
window.windowInnerWidth = window.innerWidth || $(window).width();
window.windowInnerHeight = window.innerHeight || $(window).height();

if (window.width !== window.windowInnerWidth) {
	window.scrollBar = true;
} else {
	window.scrollBar = false;
}

var arrowLeft = '<svg viewBox="0 0 90 90" width="90" height="90" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"><g><path d="M45 89.8A44.9 44.9 0 1 1 45 0a44.9 44.9 0 0 1 0 89.8zm0-86.6a41.8 41.8 0 1 0 0 83.7 41.8 41.8 0 0 0 0-83.7z"/><path d="M50.1 60.7c-.3 0-.7-.1-1-.4L34.2 45.4c-.6-.6-.6-1.5 0-2.1l14.9-15a1.5 1.5 0 1 1 2.1 2.2L37.4 44.3l13.8 13.8a1.5 1.5 0 0 1-1 2.6z"/></g></svg>';
var arrowRight = '<svg viewBox="0 0 90 90" width="90" height="90" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"><g><path d="M44.98.15c24.72 0 44.83 20.11 44.83 44.83s-20.1 44.83-44.83 44.83S.15 69.7.15 44.98 20.26.15 44.98.15zm0 86.62a41.84 41.84 0 0 0 41.8-41.79c0-23.04-18.76-41.79-41.8-41.79S3.2 21.94 3.2 44.98a41.84 41.84 0 0 0 41.8 41.79z"/><path d="M39.82 29.24c.39 0 .78.15 1.07.45l14.85 14.86c.6.6.6 1.56 0 2.15L40.9 61.57a1.52 1.52 0 1 1-2.15-2.16l13.78-13.78-13.78-13.8a1.52 1.52 0 0 1 1.08-2.59z"/></g></svg>';

document.addEventListener( 'wpcf7mailsent', function( event ) {

	gtag( 'event', 'submit',  {
		'event_category': 'Contact Form',
		'event_label': 'SubmittedContactForm'
	});
}, false );


$(document).ready(function ($) {

	var page = {};
	page.all = true; // Pass on every page
	page.home = ($(document.body).hasClass('home'));
	page.simpleList = ($(document.body).hasClass('page-template-simple-list'));
	page.simple = ($(document.body).hasClass('page-template-simple'));
	page.location = ($(document.body).hasClass('page-template-location'));
	page.roomList = ($(document.body).hasClass('page-template-rooms'));
	page.room = ($(document.body).hasClass('single-room'));
	page.photoGallery = ($(document.body).hasClass('photo-gallery'));
	page.loyalty = ($(document.body).hasClass('page-template-loyalty'));
	page.contact = ($(document.body).hasClass('page-template-contact'));

	var $body = $(document.body);

	desktopMenu($body);

	scroller({
		trigger: $('#main-header'),
		classToggle: 'scrolled',
		breakpoint: window.width >= window.bpLarge,
		tilt: 2,     // + 2% off the screen size,
		revert: true
	});

	smoothScroll();

	(function() {
		if (page.all) {
			var $heroSlider = null;
			if ($('#sub-slider').length) {
				if ($heroSlider = $('#hero-inner')) {

					$('#hero-inner').slick({
						arrows: true,
						dots: false,
						fade: true,
						speed: 800,
						infinite: true,
						autoplay: true,
						prevArrow: '<a class="slick-prev">' + arrowLeft + '</a>',
						nextArrow: '<a class="slick-next">' + arrowRight + '</a>',
						asNavFor: page.home ? '#sub-slider' : false
					});

					$heroSlider.find('.slick-prev,.slick-next').on('click', function (e) {
						e.preventDefault();
					});


					if ( page.home ) {
						var $subSlider = null;
						if ($subSlider = $('#sub-slider')) {

							$subSlider.slick({
								autoplay: true,
								arrows: false,
								dots: false,
								infinite: true,
								slidesToShow: 1,
								slidesToScroll: 1,
								centerMode: true,
								variableWidth: true,
								focusOnSelect: true,
								asNavFor: $heroSlider,
							});
						}
					}

				}

			} else {
				if ($heroSlider = $('#hero-inner')) {

					$('#hero-inner').slick({
						arrows: true,
						dots: false,
						fade: true,
						speed: 800,
						infinite: true,
						autoplay: true,
						prevArrow: '<a class="slick-prev">' + arrowLeft + '</a>',
						nextArrow: '<a class="slick-next">' + arrowRight + '</a>',
					});

					$heroSlider.find('.slick-prev,.slick-next').on('click', function (e) {
						e.preventDefault();
					});


					if ( page.home ) {
						var $subSlider = null;
						if ($subSlider = $('#sub-slider')) {

							$subSlider.slick({
								autoplay: true,
								arrows: false,
								dots: false,
								infinite: true,
								slidesToShow: 1,
								slidesToScroll: 1,
								centerMode: true,
								variableWidth: true,
								focusOnSelect: true,
							});
						}
					}

				}

			}
		}
	})();

	(function() {
		if ( page.home ) {
			var $threeReasonItems = null;
			if ( $threeReasonItems = $('#three-reasons').find('.items') ) {

				$threeReasonItems.slick({
					arrows: false,
					dots: false,
					fade: false,
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: false,
					autoplay: false,
					prevArrow: '<a class="slick-prev">' + arrowLeft + '</a>',
					nextArrow: '<a class="slick-next">' + arrowRight + '</a>',
					responsive: [
						{
							breakpoint: 767,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								dots: true,
							}
						}
					]
				});
			}
		}
	})();

	(function() {
		if (page.home) {
			var $homePagesSlider = null;

			if ($homePagesSlider = $('#home-pages').find('.card-deck')) {
				$homePagesSlider.slick({
					arrows: true,
					dots: true,
					fade: false,
					slidesToShow: 5,
					slidesToScroll: 3,
					centerMode: true,
					variableWidth: true,
					prevArrow: '<a class="slick-prev">' + arrowLeft + '</a>',
					nextArrow: '<a class="slick-next">' + arrowRight + '</a>',
					responsive: [
						{
							breakpoint: 991,
							settings: {
								arrows: false,
								slidesToShow: 1,
								slidesToScroll: 1,
								dots: true,
							}
						}
					]
				});
			}
		}
	})();

	(function() {
		if (page.home) {
			var $awardsSlider = null;

			if ( $awardsSlider = $('#awards-section').find('.awards-icons') ) {
				$awardsSlider.slick({
					arrows: false,
					dots: true,
					fade: false,
					slidesToShow: 5,
					slidesToScroll: 5,
					centerMode: false,
					variableWidth: false,
					responsive: [
						{
							breakpoint: 1199,
							settings: {
								slidesToShow: 5,
								slidesToScroll: 5,
							}
						},
						{
							breakpoint: 767,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2,
							}
						}
					]
				});
			}
		}
	})();

	(function() {
		function jumpBack() {
			setTimeout(function() {
				$hotelSlider.slick("slickGoTo", 0);
			}, 3000);
		}
		if (page.home) {
			var $hotelSlider = null;

			if ( $hotelSlider = $('#our-hotels').find('.inner-slider') ) {
				$hotelSlider.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					speed: 1800,
					pauseOnHover: false,
					draggable: true,
					arrows: false,
					dots: false,
					fade: false,
					variableWidth: false,
					autoplay: true,
					infinite: true,
					centerMode: true,
				});
			}

			$hotelSlider.on('afterChange', function(event, slick, currentSlide) {
				if (slick.$slides.length-1 == currentSlide) {
					jumpBack();
				}
			});
		}
	})();

	(function() {
		if (page.all) {
			var $bookingDirectReasonsSlider = null;

			if ($bookingDirectReasonsSlider = $('#booking-direct-reasons').find('ul')) {

				$bookingDirectReasonsSlider.slick({
					arrows: false,
					dots: false,
					fade: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: false,
					variableWidth: true,
					cssEase: 'linear',
					speed: 6000,
					autoplay: true,
					autoplaySpeed: 0,
				});
			}
		}
	})();

	(function() {
		if (page.all) {
			var $homeOffersSlider = null;

			if ( $homeOffersSlider = $('#home-offers').find('.offers-items') ) {
				var options = {
					arrows: true,
					dots: true,
					fade: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: false,
					variableWidth: false,
					prevArrow: '<span class="slick-prev">' + arrowLeft + '</span>',
					nextArrow: '<span class="slick-next">' + arrowRight + '</span>',
				};

				// $homeOffersSlider.slick({

				// cssEase: 'linear',
				// speed: 6000,
				// autoplay: true,
				// autoplaySpeed: 0,
				// });


				$homeOffersSlider.on('init', function(event, slick) {
					slick.$slider.append('<div class="counter d-none d-lg-inline-block">' + '1/'+slick.$slides.length + '</div>');
				})
					.on('beforeChange', function(event, slick, currentSlide, nextSlide){
						slick.$slider.find('.counter').html((nextSlide + 1)+'/'+slick.$slides.length);
					})
					.slick(options);
			}
		}
	})();

	(function() {

		if (page.simple) {

			var $innerSlider = null;

			if ($innerSlider = $('#main').find('.inner-slider')) {

				$innerSlider.slick({
					arrows: true,
					dots: true,
					fade: false,
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
					centerMode: true,
					variableWidth: true,
					prevArrow: '<a class="slick-prev">' + arrowLeft + '</a>',
					nextArrow: '<a class="slick-next">' + arrowRight + '</a>',
					responsive: [
						{
							breakpoint: 992,
							settings: {
								arrows: false
							}
						}
					]
				});
			}
		}
	})();

	(function() {

		if (page.location) {

			var $innerSliderLocation = null;

			if ($innerSliderLocation = $('#main').find('.inner-slider')) {

				$innerSliderLocation.slick({
					arrows: true,
					dots: true,
					fade: false,
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
					centerMode: true,
					variableWidth: true,
					prevArrow: '<a class="slick-prev">' + arrowLeft + '</a>',
					nextArrow: '<a class="slick-next">' + arrowRight + '</a>',
					responsive: [
						{
							breakpoint: 992,
							settings: {
								arrows: false
							}
						}
					]
				});
			}
		}
	})();

	(function() {
		if (page.room) {
			var $relatedSlider = null;
			var $slides_to_show = $('#related-pages').find('.listing-wrapper').find('article').length;


			if (( $relatedSlider = $('#related-pages').find('.listing-wrapper') ) && ( $slides_to_show > 1 )) {
				$relatedSlider.slick({
					arrows: false,
					dots: true,
					fade: false,
					slidesToScroll: 1,
					slidesToShow: ($slides_to_show) > 2 ? 3 : 2,
					centerMode: false,
					variableWidth: false,
					prevArrow: '<a class="slick-prev">' + arrowLeft + '</a>',
					nextArrow: '<a class="slick-next">' + arrowRight + '</a>',
					responsive: [
						{
							breakpoint: 1441,
							settings: {
								slidesToShow: 2
							}
						},
						{
							breakpoint: 767,
							settings: {
								slidesToShow: 1
							}
						}
					]
				});
			}
		}
	})();
	(function() {
		if (page.room) {
			var $galleryPhotosSlider = $('#gallery-photos');

			// Photoswipe initialize
			$galleryPhotosSlider.photoswipeLightbox($galleryPhotosSlider.data('photoswipe-options'));

			// Slick initialize
			if ( $galleryPhotosSlider ) {
				$galleryPhotosSlider.slick({
					arrows: true,
					dots: true,
					fade: false,
					infinite: false,
					slidesToShow: 4,
					slidesToScroll: 1,
					centerMode: false,
					variableWidth: false,
					prevArrow: '<span class="slick-prev">' + arrowLeft + '</span>',
					nextArrow: '<span class="slick-next">' + arrowRight + '</span>',
					responsive: [
						{
							breakpoint: 1280,
							settings: {
								slidesToShow: 3
							}
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 2
							}
						}
					]
				});
			}
		}
	})();

	(function() {

		$.fn.webhotelierForm = function(options) {
			var el = $(this);

			var settings = $.extend({
				"split_dates": $(this).data("split_dates"),
				"icon_dates": $(this).data("icon_date"),
			}, options);

			var checkinDateSplit = el.find("#checkin-date-split");

			function getField(id) {
				var el = $("#" + id + "-picker");
				return el.length ? el : null;
			}

			function fillSplitDates(id) {
				var el = getField(id);
				if (el !== null) {
					var date = el.datepicker("getDate");
					el.parent().find(".day").text(date.getDate());
					el.parent().find(".month").text(date.toLocaleString(document.documentElement.lang,{month: "short"}));
					el.parent().find(".year").text(date.getFullYear());
				}
			}

			function pickerSetup(id, date) {
				var el = getField(id);

				if (el !== null) {
					var checkin = (id === "checkin");

					el.datepicker({
						altField: el.get(0).form[id],
						altFormat: "yy-mm-dd",
						dateFormat: "d M yy",
						onSelect: function () {
							if (checkin && getField("checkout") !== null) {
								var constraint = new Date(el.datepicker("getDate"));
								constraint.setDate(constraint.getDate() + 1);
								getField("checkout").datepicker("option", "minDate", constraint);
							}
							if ( settings.split_dates ) {
								fillSplitDates(id);
							}
						},
						numberOfMonths: 2,
						mandatory: true,
						firstDay: 1,
						minDate: checkin ? 0 : 1,
						maxDate: "+2y",
						showOn: settings.icon_date ? "button" : "focus",
						buttonImage: settings.icon_date ? settings.icon_date : "",
						buttonImageOnly: settings.icon_date ? "true" : "false",
						buttonText: "Select date"
					});
					// el.datepicker("setDate", date);

					if ( checkinDateSplit.length > 0 ) {
						fillSplitDates(id);
					}
				}
			}

			pickerSetup("checkin", "+0");
			pickerSetup("checkout", "+1");

			if ( checkinDateSplit.length > 0 ) {
				$("#checkin-date-split, #checkout-date-split").on("click", function() {
					$( this ).parent().find("input").datepicker( "show" );
				});
			} else {
				$("#checkin-picker, #checkout-picker").on("click", function() {
					$( this ).datepicker( "show" );
				});
			}

			// $( this ).find("select").selectmenu({
			//     icons: { button: "ui-icon-caret-2-n-s" }
			// });

		};

		/**
		 * Webhotelier Form
		 */
		if ( page.home ) {
			var $webhotelierForm = $("#main-form");
			if ($webhotelierForm.length > 0) {
				var elWebhotelierForm = $webhotelierForm;
				elWebhotelierForm.webhotelierForm(elWebhotelierForm.data("json"));
			}
		}

	})();

	function smoothScroll(options) {
		options = $.extend(
			{
				triggerElement: '#loyalty-navigation a',
				wrapper: 'html, body',
				watchElement: '.scroll-down',
				page: true,
				speed: 500,
				margin: - $('#main-header').outerHeight()
			}, options);

		if (page.loyalty) {
			$(options.triggerElement).on({
				'click': function () {
					//var topOffset = $(this).attr('href').offset().top;

					console.log(options.margin);

					$('html, body').animate({
						scrollTop: $($(this).attr('href')).offset().top + options.margin
					}, 500);

					return false;
				}
			});
		}

	}

	/**
	 * Read More Toggler
	 */
	$.fn.readMoreToggler = function() {
		var readMoreToggle = $(this),
			entryContent = $(this).parent().find(".entry-content"),
			readMoreToggleLink = readMoreToggle.find(".read-more-toggle-link"),
			entryContentHeight = entryContent.height(),
			entryContentMaxHeight = readMoreToggleLink.attr("data-max-height");

		if ( entryContentHeight > entryContentMaxHeight ) {
			entryContent.css("max-height", entryContentMaxHeight + "px" ).addClass("faded");
			readMoreToggle.removeClass("d-none");
			readMoreToggleLink.on("click", function(e) {
				e.preventDefault();
				$(this).toggleClass("toggled");
				if ($(this).hasClass("toggled")) {
					$(this).html($(this).attr("data-close-text"));
				}
				else {
					$(this).html($(this).attr("data-open-text"));
				}
				entryContent.toggleClass("toggled");
			});
		}
	};

	if ( page.simpleList ) {
		var readMoreToggle = $(".read-more-toggle");
		if (readMoreToggle.length > 0) {
			readMoreToggle.each(function () {
				$(this).readMoreToggler();
			});
		}
	}

	/**
	 * Newsletter Form
	 */
	var $secondaryFields = $('#mc_embed_signup_scroll #newsletter-fields');
	if ($secondaryFields.parent().find('#mce-EMAIL').length > 0) {
		$("#mc_embed_signup_scroll #mce-EMAIL").focusin(function() {
			$secondaryFields.fadeIn('slow').removeClass('d-none');
		});
	}

	/**
	 * Contact Form
	 */
	if (page.contact) {
		var disableSubmit = false;
		jQuery('input.wpcf7-submit[type="submit"]').click(function() {
			jQuery(':input[type="submit"]').attr('value',"Sending...")
			if (disableSubmit == true) {
				return false;
			}
			disableSubmit = true;
			return true;
		});
		var wpcf7Elm = document.querySelector( '.wpcf7' );
		wpcf7Elm.addEventListener( 'wpcf7submit', function( event ) {
			jQuery(':input[type="submit"]').attr('value',"Submit")
			disableSubmit = false;
		}, false );
	}

	function setCookie(key, value, expiry) {
		var expires = new Date();
		expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
		document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
	}

	function getCookie(key) {
		var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
		return keyValue ? keyValue[2] : null;
	}


	if ( ! getCookie( 'fixed-message' ) && $('#fixed-message').length > 0 ) {
		$('#fixed-message').removeClass('hide');
	}

	$('#close-message').on('click', function() {
		$('#fixed-message').addClass('hide');
		setCookie('fixed-message','1','1');
	});

});


$(window).on('load', function () {
	if (window.width > window.bpLarge) {
		//$("#main-navbar").css('padding-top', $('#main-header').height() + 40);
	}
	if (!$('#hero-inner').length)
		$('body').css('padding-top',$('#main-header').outerHeight());
});

function scroller(options) {

	options = $.extend(
		{
			trigger: '.animate-this',
			page: true,
			tilt: 5,
			classToggle: 'revealed',
			breakpoint: true,
			screenHeight: window.innerHeight,
			revert: false
		},
		options
	);

	var tiltHeight = options.screenHeight / 100 * options.tilt;

	// options.tilt = (options.screenHeight) / options.tilt;

	// if this page is true and if this breakpoint is true
	if (options.page && options.breakpoint) {

		// if exists at least 1 item
		if ($(options.trigger).length) {

			$(options.trigger).each(function () {

				var $thisItem = $(this);

				var flag = true;

				// Trigger on scroll
				$(document).on("scroll", function () {

					// If flag is false do not removed classes
					if (flag) {

						var scroll = getCurrentScroll();

						if ($thisItem.position().top + tiltHeight < scroll) {

							if ($thisItem.hasClass(options.classToggle)) {
								// do not do anything
							} else {
								$thisItem.addClass(options.classToggle);

								if (!options.revert) {
									flag = options.revert;
								}
							}

						} else {

							if ($thisItem.hasClass(options.classToggle)) {

								$thisItem.removeClass(options.classToggle);

							}
						}
					}
				});

				/**
				 * @fixme do not repeat your self! It's the same as the above code
				 */
				if (flag) {

					var scroll = getCurrentScroll();

					if ($thisItem.position().top + tiltHeight < scroll) {

						if ($thisItem.hasClass(options.classToggle)) {
							// do not do anything
						} else {
							$thisItem.addClass(options.classToggle);

							if (!options.revert) {
								flag = options.revert;
							}
						}

					} else {

						if ($thisItem.hasClass(options.classToggle)) {

							$thisItem.removeClass(options.classToggle);

						}
					}
				}
			});
		}

	}

}

function getCurrentScroll() {
	return window.pageYOffset || document.documentElement.scrollTop;
}


function desktopMenu($body) {
	"use strict";

	var $wrapperNavbar = $('#nav-wrapper'),
		$openBtn = $('#main-nav__button--toggle'),
		$overlay = $('#menu-overlay'),
		$menu = $('#main-header');

	var opened = $wrapperNavbar.hasClass('open');

	$openBtn.on('click', function() {

		$wrapperNavbar.toggleClass('open');
		$openBtn.toggleClass('open');
		$body.toggleClass('overflow-hidden');
		$body.toggleClass('menu-opened');
		$menu.toggleClass('opened');
	});

	$overlay.on('click', function() {
		$wrapperNavbar.removeClass('open');
		$openBtn.removeClass('open');
		$body.removeClass('overflow-hidden menu-opened');
		$menu.removeClass('opened');
	});
}

function mobileMenu() {
	// var $menu = $("#main-navbar");
	// var logo = $('#main-header').find('.logo').parent().html();
	//
	// $menu.mmenu({
	// 	wrappers: [
	// 		"wordpress"
	// 	],
	// 	// extensions: [
	// 	// 	"position-front"
	// 	// ],
	// 	// navbars     : [
	// 	// 	{
	// 	// 		height  : 3,
	// 	// 		content : [
	// 	// 			logo
	// 	// 		]
	// 	// 	}, true
	// 	// ],
	// 	header: true,
	// 	className: {
	// 		"selected": "active"
	// 	},
	// 	offCanvas: {
	// 		position: "left"
	// 	}
	// });
	// var api = $menu.data("mmenu");
	//
	// $(".main-nav__button--toggle").click(
	// 	function (evnt) {
	// 		evnt.preventDefault();
	// 		api.open();
	// 	}
	// );

	//add social media
	//var mobileInformation = $('#nav-wrapper .infoWrapper').html();
	//$('#nav-wrapper .infoWrapper').remove();
	//$('#main-navbar .mm-listview').append('<li><div class="infoWrapper">'+mobileInformation+'</div></li>');

	//remove bootstrap classes
	// $menu.removeClass('nav navbar-nav');
	// $('#main-navbar ul').removeClass('dropdown-menu animated fadeInDown');
	// $('#main-navbar li').removeClass('dropdown');
	// $('#main-navbar li a').removeClass('dropdown-toggle').removeAttr("data-toggle data-target");

	// show logo instead of menu title text
	//$('#main-navbar .mm-navbar__title').html(logo);

}

// Photoswipe Lightbox
$.fn.photoswipeLightbox = function(options) {
	var el = $(this);

	var settings = $.extend({
		closeOnScroll: true,
		escKey: true,
		arrowKeys: true,
		loop: true,
		history: true,
		focus: true,
		modal: true,
		showHideOpacity: true,
		closeEl: true,
		captionEl: true,
		fullscreenEl: true,
		zoomEl: true,
		shareEl: true,
		counterEl: true,
		arrowEl: true,
		preloaderEl: true,
	}, options);

	el.each( function() {
		var $pic     = $(this),
			getItems = function() {
				var items = [];
				$pic.find('a').each(function() {

					var $href   = $(this).attr('href'),
						$w   = $(this).data('width'),
						$h  = $(this).data('height'),
						$msrc  = $(this).find('img').attr('src'),
						$title  = $(this).data('title'),
						$pid  = $(this).data('slug');

					var item = {
						src : $href,
						w   : $w,
						h   : $h,
						msrc   : $msrc,
						title   : $title,
						pid   : $pid
					};

					items.push(item);
				});
				return items;
			};

		var items = getItems();

		var $pswp = $('.pswp')[0];
		$pic.on('click', 'a', function(event) {
			event.preventDefault();

			var $index = $(this).data('index');
			var options = {
				index: $index,
				bgOpacity: 0.7,
				spacing: 0.12,
				allowPanToNext: true,
				pinchToClose: true,
				closeOnScroll: settings.closeOnScroll,
				closeOnVerticalDrag: true,
				escKey: settings.escKey,
				arrowKeys: settings.arrowKeys,
				history: settings.history,
				mouseUsed: false,
				loop: settings.loop,
				focus: settings.focus,
				modal: settings.modal,
				showHideOpacity: settings.showHideOpacity,
				showAnimationDuration: 333,
				hideAnimationDuration: 333,
				closeEl: settings.closeEl,
				captionEl: settings.captionEl,
				fullscreenEl: settings.fullscreenEl,
				zoomEl:  settings.zoomEl,
				shareEl:  settings.shareEl,
				counterEl: settings.counterEl,
				arrowEl: settings.arrowEl,
				preloaderEl:  settings.preloaderEl,
			};

			// Initialize PhotoSwipe
			var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
			lightBox.init();
		});
	});
};

// Masonry Gallery
var $gallery = $('#masonry-gallery');
if ($gallery.length > 0) {
	$gallery.imagesLoaded( function() {
		// init Isotope after all images have loaded
		$gallery.isotope({
			itemSelector: '.gallery-item',
			percentPosition: true,

			// layout mode options
			masonry: {
				gutter: '.gallery-gutter-sizer',
				columnWidth: '.gallery-item-sizer'
			}

		});
	});

	// filter items on button click
	$('#masonry-gallery-filters li').on('click', 'a', function() {
		$gallery.isotope({
			filter: $(this).attr('data-filter')
		});
	});

	// Lightbox
	$gallery.photoswipeLightbox($gallery.data('photoswipe-options'));
}

/**
 * Masonry Gallery
 */

var $masonryGalleryDownloads = $("#masonry-gallery-downloads");
if ($masonryGalleryDownloads.length > 0) {
	$masonryGalleryDownloads.imagesLoaded( function() {
		$masonryGalleryDownloads.packery(
			{
				itemSelector: '.gallery-item',
				gutter: 10
			}
		);
	});
}
